import { GeneratedType } from "@cosmjs/proto-signing";
import { MsgUpdateParams } from "./types/cosmos/consensus/v1/tx";

const msgTypes: Array<[string, GeneratedType]>  = [
    ["/cosmos.consensus.v1.MsgUpdateParams", MsgUpdateParams],
    
];

export { msgTypes }